import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'next/router';
import classNames from 'classnames';
import get from '../../../utils/get';
import VideoPlayerLazy from './VideoPlayerLazy';

class VideoPlayerHandler extends React.Component {
    render() {
        const {
            barn,
            posterImage,
            blockedForChildren,
            svtId,
            autoPlay,
            title,
            episodeTitle,
            nextVideoIsBinge,
            visionId,
            escenicId,
            __typename,
            router,
            __videoType,
            nextVideoTitle,
            nextVideoUrl,
            skipNextScreen,
            nextVideoPosterImageId,
            nextVideoPosterImageAltText,
            nextVideoPosterImageChanged,
            parentalLockConfirmed, // ?
            startPosition, // ?
            isKidsGenre,
            highlights,
            forcePlay,
            titleArticleId,
            autoPlayEnabled,
            parentalLockEnabled,
            continueWatchingEnabled,
            useVideoCompatibilityMode,
            url,
            videos,
            updateAccessibilityVersion,
            parentUrl,
            associatedContent,
            endCreditStart, // A/B-test Skip Credits sep 2021
            nextVideoId, // A/B-test Skip Credits sep 2021
            videoLength, // A/B-test Skip Credits sep 2021
            parentType, // A/B-test Skip Credits sep 2021
        } = this.props;

        const poster = nextVideoIsBinge.get('isBinge') ? null : posterImage;
        const position = parseInt(get(router, 'query.position', 0), 10);
        const shouldAutoPlay = autoPlay && (parentalLockConfirmed || !blockedForChildren);

        // temporary filter of highlights for internal use. SSG 13 aug 2021
        const filteredHighlights = highlights?.filter((item) => !item.slug.startsWith('intern-'));

        return (
            <VideoPlayerLazy
                className={classNames({
                    playJsParentalControl: blockedForChildren,
                })}
                isModal
                barn={barn}
                poster={poster}
                videoId={svtId}
                autoPlayEnabled={autoPlayEnabled}
                parentalLockEnabled={parentalLockEnabled}
                continueWatchingEnabled={continueWatchingEnabled}
                autoPlay={shouldAutoPlay}
                forcePlay={forcePlay}
                startPosition={position > 0 ? position : startPosition}
                positionFromQuery={position}
                bingeAutoPlay={nextVideoIsBinge.get('isAutoPlay', false)}
                autoFocusOnPlay={true}
                isChildProtected={blockedForChildren}
                isKidsGenre={isKidsGenre}
                parentalLockConfirmed={parentalLockConfirmed}
                __typename={__typename}
                __videoType={__videoType}
                visionId={visionId}
                escenicId={escenicId}
                nextVideoTitle={nextVideoTitle}
                nextVideoUrl={nextVideoUrl}
                skipNextScreen={skipNextScreen}
                nextVideoPosterImageId={nextVideoPosterImageId}
                nextVideoPosterImageChanged={nextVideoPosterImageChanged}
                nextVideoPosterImageAltText={nextVideoPosterImageAltText}
                highlights={filteredHighlights} // temporary filter of highlights for internal use. SSG 13 aug 2021
                titleArticleId={titleArticleId}
                title={title}
                episodeTitle={episodeTitle}
                useVideoCompatibilityMode={useVideoCompatibilityMode}
                url={url}
                videos={videos}
                updateAccessibilityVersion={updateAccessibilityVersion}
                parentUrl={parentUrl}
                associatedContent={associatedContent}
                endCreditStart={endCreditStart} // A/B-test Skip Credits sep 2021
                nextVideoId={nextVideoId} // A/B-test Skip Credits sep 2021
                videoLength={videoLength} // A/B-test Skip Credits sep 2021
                parentType={parentType} // A/B-test Skip Credits sep 2021
            />
        );
    }
}

VideoPlayerHandler.propTypes = {
    autoPlayEnabled: PropTypes.bool,
    parentalLockEnabled: PropTypes.string,
    continueWatchingEnabled: PropTypes.bool,
    barn: PropTypes.bool,
    posterImage: PropTypes.string.isRequired,
    blockedForChildren: PropTypes.bool.isRequired,
    svtId: PropTypes.string.isRequired,
    visionId: PropTypes.string.isRequired,
    titleArticleId: PropTypes.string.isRequired,
    className: PropTypes.string,
    autoPlay: PropTypes.bool,
    positionToggle: PropTypes.bool,
    nextVideoIsBinge: PropTypes.object,
    skipNextScreen: PropTypes.bool,
    nextVideoUrl: PropTypes.string,
    nextVideoTitle: PropTypes.string,
    nextVideoPosterImageId: PropTypes.string,
    nextVideoPosterImageChanged: PropTypes.number,
    isKidsGenre: PropTypes.bool,
    router: PropTypes.object.isRequired,
    startPosition: PropTypes.number,
    position: PropTypes.number,
    parentalLockConfirmed: PropTypes.bool,
    highlights: PropTypes.array,
    episodeTitle: PropTypes.string,
    title: PropTypes.string,
    useVideoCompatibilityMode: PropTypes.bool,
    url: PropTypes.string,
    parentUrl: PropTypes.string,
    updateAccessibilityVersion: PropTypes.func,
    associatedContent: PropTypes.array,
};

export default withRouter(VideoPlayerHandler);
